import React, { useState, useEffect } from "react";

import CheckUp from "../../Components/Forms/CheckUp/CheckUp";
import AdmissionForm from "../../Components/Forms/AdmissionForm/AdmissionForm";
import OutPatient from "../../Components/Forms/OutPatient/OutPatient";
import Therapeutics from "../../Components/Forms/Therapeutics/Therapeutics";
import Diagnostics from "../../Components/Diagnosis/Diagnostics";
import MedicalSummary from "../../Components/Forms/MedicalSummary/MedicalSummary";

import { useParams } from "react-router-dom";
import { Tabs } from "antd";
import PhysicalExamination from "../../Components/Forms/PhysicalExamination/PhysicalExamination";
// import PhysicalExaminationSample from "../../Components/Forms/PhysicalExamination/PhysicalExaminationSample";

const { TabPane } = Tabs;

function CheckupTabs({
  assessment,
  fetchAssessmentHistory,
  complaint,
  doctor_id,
  selectedCheckUpTab,
  setSelectedCheckUpTab,
  patientDetails,
  doctorOptions,
  selectedTab,
  setSelectedTab,
  selectedFormTab,
  setSelectedFormTab,
}) {
  const { id } = useParams();
  const [admitPatient, setAdmitPatient] = useState(false);
  const [outPatient, setOutPatient] = useState(false);
  // const [addOutPatientData, setAddOutPatientData] = useState({
  //   professional_fee_method: "",
  //   professional_fee: "",
  // });
  const [addOutPatientData, setAddOutPatientData] = useState({
    professional_fee_method:
      patientDetails.ph_check === "1" ? "konsulta" : "No PF", // default: no PF if not philhealth member
    professional_fee: "",
  });
  const [selectedDiagnosticTests, setSelectedDiagnosticTests] = useState({});
  const [selectedPrintDiagnostics, setSelectedPrintDiagnostics] = useState({});

  useEffect(() => {
    // Update the date every minute to handle changes in the current time
    const intervalId = setInterval(() => {
      setAddDiagnostic((prev) => ({
        ...prev,
        date: getFormattedDateTime(),
      }));
    }, 60000);

    return () => clearInterval(intervalId); // Cleanup on component unmount
  }, []);

  const getFormattedDateTime = () => {
    const philippinesTime = new Date().toLocaleString("en-US", {
      timeZone: "Asia/Manila",
    });

    const philippinesDate = new Date(philippinesTime);

    const formattedDateTime =
      philippinesDate.getFullYear() +
      "-" +
      String(philippinesDate.getMonth() + 1).padStart(2, "0") +
      "-" +
      String(philippinesDate.getDate()).padStart(2, "0") +
      "T" +
      String(philippinesDate.getHours()).padStart(2, "0") +
      ":" +
      String(philippinesDate.getMinutes()).padStart(2, "0");

    return formattedDateTime;
  };

  const [addDiagnostic, setAddDiagnostic] = useState({
    // date: getFormattedDateTime(),
    // diagnostic_date: "",
    fasting: "",
    notes: "",
  });

  const [addCheckUpData, setAddCheckUpData] = useState({
    is_surgical_outpatient: "0",
    procedure: "",
    pf: "",
    notes: "",
    is_sunday_patient: "0",
    last_checkup_date: "",
    complaint: "",
    checkup_note: "",
    doctor_id: "",
    illness_history: "",
    general_survey: "",
    heent: "",
    cl: "",
    cvs: "",
    abdomen: "",
    skin: "",
    extremities: "",
    neurologic: "",
    pertinent_diagnostics: "",
    // diagnosis: "",
    // sub_diagnosis: "",
    from_type: "",
  });

  const [addCheckupDiagnosis, setAddCheckupDiagnosis] = useState([
    {
      id: "",
      diagnosis_name: "",
      sub_diagnosis: "",
    },
  ]);

  const [selectedLabs, setSelectedLabs] = useState([]);

  const [addAdmissionData, setAddAdmissionData] = useState({
    problem: "",
    health_condition: "",
    vital_signs: "",
    ambulation: "",
    cl: "",
    iso_precaution: "",
    diet: "",
    ivf: "",
    tpr: "",
    i_and_o: "",
    plan: "",
    labs: "",
    xray: "",
    treatment: "",
  });

  // Function for showing the admit tab
  const handleShowAdmit = (data) => {
    setAdmitPatient(data);
    setOutPatient(false);
    setSelectedCheckUpTab("admission");
  };

  // Function for showing the outpatient tab
  const handleShowOutPatient = (data) => {
    setOutPatient(data);
    setAdmitPatient(false);
    setSelectedCheckUpTab("out_patient");
  };

  useEffect(() => {
    if (JSON.stringify(assessment) !== "{}") {
      var mappedDiagnosis = assessment?.diagnosis?.map((d) => ({
        id: d?.id || "",
        diagnosis_name: d?.diagnosis_name || "",
        sub_diagnosis: "",
      }));
      setAddCheckupDiagnosis(mappedDiagnosis);

      var formattedDiagnosis = (
        <ul style={{ paddingLeft: 20, margin: 0 }}>
          {(assessment.diagnosis || []).map((d, idx) => (
            <li key={idx}>{d.diagnosis_name}</li>
          ))}
        </ul>
      );

      setAddCheckUpData({
        complaint,
        doctor_id,
        formatted_diagnosis: formattedDiagnosis,
        ...assessment,
      });
      // if (assessment?.inpatients?.length !== 0) {
      //   setAddAdmissionData(assessment?.inpatients[0]);
      // }
      if (assessment.diagnostics.length !== 0) {
        var _diagnostics = assessment.diagnostics[0];
        var selectedDiagnosticTests = {};
        var selectedNewLabs = {};
        _diagnostics.diagnostic_items &&
          _diagnostics.diagnostic_items.forEach((d) => {
            selectedDiagnosticTests[d.lab_name] = d.lab_schedule
              ? d.lab_schedule.replace(" ", "T")
              : null;
            selectedDiagnosticTests[`${d.lab_name}_id`] = d.id || null;
            selectedDiagnosticTests[`${d.lab_name}_type`] = d.type || null;
            selectedDiagnosticTests[`${d.lab_name}_subtype`] =
              d.sub_type || null;
            selectedDiagnosticTests[`${d.lab_name}_is_new`] = d.is_new; // tracks the lab test that is/were newly added previously
            selectedDiagnosticTests[`${d.lab_name}_is_existing`] = "1"; // tracks the existence of lab test
          });

        if (_diagnostics.diagnostic_items) {
          selectedNewLabs = _diagnostics.diagnostic_items.map((d) => ({
            diagnostic_id: d.id,
            name: d.lab_name,
            id: d.lab_test_id,
          }));
        }

        var printDiagnostics = {
          laboratory: [],
          xray: [],
          ct_scan: [],
          ultrasound: [],
          others: [],
        };

        _diagnostics.diagnostic_items &&
          _diagnostics.diagnostic_items.forEach((lab) => {
            var type = lab?.type?.toLowerCase();
            var sub_type = lab?.sub_type?.toLowerCase();

            var item = {
              lab_test_name: lab?.lab_name || "",
              lab_schedule: lab?.lab_schedule || "",
              is_new: lab?.is_new || "",
            };

            if (type === "laboratory") {
              printDiagnostics.laboratory.push(item);
            } else if (type === "radiology" || type === "imaging") {
              if (sub_type === "xray") {
                printDiagnostics.xray.push(item);
              } else if (sub_type === "ct_scan") {
                printDiagnostics.ct_scan.push(item);
              } else if (sub_type === "ultrasound") {
                printDiagnostics.ultrasound.push(item);
              } else {
                printDiagnostics.others.push(item);
              }
            } else {
              printDiagnostics.others.push(item);
            }
          });

        var _parsed = {
          id: _diagnostics.id,
          notes: _diagnostics?.notes || "",
          fasting: _diagnostics?.fasting,
          patient_id: _diagnostics.patient_id,
          assessment_id: _diagnostics.assessment_id,
          case_number: _diagnostics?.case_number || "",
          diagnostic_date: _diagnostics.diagnostic_date,
          last_meal: _diagnostics.last_meal,
          room_number: _diagnostics?.room_number || "",
          is_philhealth_member: _diagnostics.is_philhealth_member,
          chief_complaint: _diagnostics.chief_complaint,
          doctor_name: _diagnostics.doctor_name,
          doctor_id: _diagnostics.doctor_id,
        };
        setAddDiagnostic(_parsed);
        setSelectedDiagnosticTests(selectedDiagnosticTests);
        setSelectedPrintDiagnostics(printDiagnostics);
        setSelectedLabs(selectedNewLabs);
      }
    } else {
      setAddCheckUpData({ complaint, doctor_id });
    }

    if (assessment.type === "for_admission" || assessment.type === "admit") {
      setAdmitPatient(true);
    } else if (assessment.type === "outpatient") {
      setOutPatient(true);
      setAddCheckUpData({
        complaint,
        doctor_id,
        formatted_diagnosis: formattedDiagnosis,
        ...assessment,
      });
      if (assessment.outpatients.length !== 0) {
        setAddOutPatientData(assessment.outpatients[0]);
      } else {
        // const professional_fee_method = patientDetails.hmo_type
        //   ? "hmo"
        //   : patientDetails.corporate_type
        //   ? "corporate"
        //   : "cash";
        // const professional_fee =
        //   professional_fee_method === "cash"
        //     ? assessment.doctor_id === "3"
        //       ? "500"
        //       : "450"
        //     : "0";
        // const professional_fee_method = patientDetails.hmo_type
        //   ? "hmo"
        //   : patientDetails.corporate_type
        //   ? "corporate"
        //   : "cash";
        const professional_fee_method = "No PF";
        const professional_fee = "0";
        setAddOutPatientData((prevState) => ({
          ...prevState,
          professional_fee,
          professional_fee_method,
        }));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assessment]);

  return (
    <div className="App">
      <div className="col p-1">
        <div className="row mt-3 check-up-container">
          <div className="col-sm-12">
            <div className="row card-container">
              <Tabs
                activeKey={selectedCheckUpTab}
                id="PO-tabs"
                type="card"
                animated="true"
                size="large"
                className="check-tab"
                onChange={(e) => {
                  setSelectedCheckUpTab(e);
                }}
              >
                <TabPane key="checkup" tab="Check Up">
                  <CheckUp
                    showAdmit={handleShowAdmit}
                    showOutPatient={handleShowOutPatient}
                    addCheckUpData={addCheckUpData}
                    setAddCheckUpData={setAddCheckUpData}
                    selectedLabs={selectedLabs}
                    setSelectedLabs={setSelectedLabs}
                    addCheckupDiagnosis={addCheckupDiagnosis}
                    setAddCheckupDiagnosis={setAddCheckupDiagnosis}
                    fetchAssessmentHistory={fetchAssessmentHistory}
                    assessment={assessment}
                    doctorOptions={doctorOptions}
                    setSelectedCheckUpTab={setSelectedCheckUpTab}
                  />
                </TabPane>
                {/* <TabPane key="physical_examination" tab="Physical Examination">
                  <PhysicalExamination
                    showAdmit={handleShowAdmit}
                    showOutPatient={handleShowOutPatient}
                    addCheckUpData={addCheckUpData}
                    setAddCheckUpData={setAddCheckUpData}
                    selectedLabs={selectedLabs}
                    setSelectedLabs={setSelectedLabs}
                    addCheckupDiagnosis={addCheckupDiagnosis}
                    setAddCheckupDiagnosis={setAddCheckupDiagnosis}
                    fetchAssessmentHistory={fetchAssessmentHistory}
                    assessment={assessment}
                    doctorOptions={doctorOptions}
                  />
                </TabPane> */}
                {/* <TabPane
                  key="physical_examination_sample"
                  tab="Physical Examination Sample"
                >
                  <PhysicalExaminationSample
                    showAdmit={handleShowAdmit}
                    showOutPatient={handleShowOutPatient}
                    addCheckUpData={addCheckUpData}
                    setAddCheckUpData={setAddCheckUpData}
                    selectedLabs={selectedLabs}
                    setSelectedLabs={setSelectedLabs}
                    addCheckupDiagnosis={addCheckupDiagnosis}
                    setAddCheckupDiagnosis={setAddCheckupDiagnosis}
                    fetchAssessmentHistory={fetchAssessmentHistory}
                    assessment={assessment}
                    doctorOptions={doctorOptions}
                  />
                </TabPane> */}
                {(admitPatient || outPatient) && (
                  <TabPane key="assessment" tab="Diagnostics">
                    <Diagnostics
                      assessmentType={assessment.type} //inpatient, outpatient
                      patientId={id}
                      patientDetails={patientDetails}
                      assessmentId={addCheckUpData.id}
                      addCheckUpData={addCheckUpData}
                      selectedLabs={selectedLabs}
                      setSelectedLabs={setSelectedLabs}
                      showAdmit={handleShowAdmit}
                      showOutPatient={handleShowOutPatient}
                      addDiagnostic={{
                        ...addDiagnostic,
                        chief_complaint: assessment.complaint,
                      }}
                      setAddDiagnostic={setAddDiagnostic}
                      selectedDiagnosticTests={selectedDiagnosticTests}
                      setSelectedDiagnosticTests={setSelectedDiagnosticTests}
                      fetchAssessmentHistory={fetchAssessmentHistory}
                      doctorOptions={doctorOptions}
                      setSelectedCheckUpTab={setSelectedCheckUpTab}
                    />
                  </TabPane>
                )}
                {admitPatient || outPatient ? (
                  <TabPane key="therapeutics" tab="Therapeutics">
                    <Therapeutics
                      patientId={id}
                      assessmentId={addCheckUpData.id}
                      setSelectedCheckUpTab={setSelectedCheckUpTab}
                    />
                  </TabPane>
                ) : null}
                {admitPatient && (
                  <TabPane key="admission" tab="Admission Form">
                    <AdmissionForm
                      assessment_id={addCheckUpData.id}
                      assessmentData={addCheckUpData}
                      showAdmit={handleShowAdmit}
                      showOutPatient={handleShowOutPatient}
                      addAdmissionData={addAdmissionData}
                      setAddAdmissionData={setAddAdmissionData}
                      patientDetails={addCheckUpData}
                      diagnostics={{
                        ...addDiagnostic,
                        diagnostic_tests: Object.keys(selectedDiagnosticTests),
                        diagnostic_dates: Object.values(
                          selectedDiagnosticTests
                        ),
                      }}
                      printDiagnostics={selectedPrintDiagnostics}
                    />
                  </TabPane>
                )}
                {outPatient && (
                  <TabPane key="out_patient" tab="Out Patient Form">
                    <OutPatient
                      assessmentId={addCheckUpData.id}
                      addCheckUpData={addCheckUpData}
                      showAdmit={handleShowAdmit}
                      showOutPatient={handleShowOutPatient}
                      addOutPatientData={{
                        ...addOutPatientData,
                        hmo_id: patientDetails.hmo_id,
                        hmo_type: patientDetails.hmo_type,
                        corporate_id: patientDetails.corporate_id,
                        corporate_type: patientDetails.corporate_type,
                        doctor_id:
                          patientDetails?.assessment?.[0]?.doctor_id || "",
                        ph_check: patientDetails.ph_check,
                      }}
                      setAddOutPatientData={setAddOutPatientData}
                      fetchAssessmentHistory={fetchAssessmentHistory}
                      patientDetails={addCheckUpData}
                      diagnostics={{
                        ...addDiagnostic,
                        diagnostic_tests: Object.keys(selectedDiagnosticTests),
                        diagnostic_dates: Object.values(
                          selectedDiagnosticTests
                        ),
                      }}
                      doctorOptions={doctorOptions}
                      printDiagnostics={selectedPrintDiagnostics}
                      selectedTab={selectedTab}
                      setSelectedTab={setSelectedTab}
                      selectedFormTab={selectedFormTab}
                      setSelectedFormTab={setSelectedFormTab}
                      assessment={assessment}
                      selectedLabs={selectedLabs}
                      patientData={patientDetails}
                    />
                  </TabPane>
                )}
                {admitPatient || outPatient ? (
                  <TabPane key="baby_book" tab="View Medical Summary">
                    <MedicalSummary id={id} isFetchData={"medical_summary"} />
                  </TabPane>
                ) : null}
              </Tabs>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CheckupTabs;
